// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D3-H2F0","title":"_5D2pmhAi","is-uppercase":"_5D2--RYC","line":"_5D2tI1Lt"};